module.exports = __webpack_public_path__ + "img/camera_board2.888dda92.png";